import React from "react";

const GeographicBreakdown = ({ geoData }) => (
    <section className="card">
        <h3>Geographic Breakdown</h3>
        <table>
            <thead>
                <tr>
                    <th>Zone</th>
                    <th>State</th>
                    <th>LGA</th>
                    <th>Budget</th>
                    <th>Spent</th>
                </tr>
            </thead>
            <tbody>
                {geoData.map((row, i) => (
                    <tr key={i}>
                        <td>{row.zone}</td>
                        <td>{row.state}</td>
                        <td>{row.lga}</td>
                        <td>{row.budget.toLocaleString()}</td>
                        <td>{row.spent.toLocaleString()}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </section>
);

export default GeographicBreakdown;